import {
  SET_SESSION,
  CLEAR_SESSION,
  REFRESH_SESSION,
  REFRESH_SESSION_FAILED,
  REFRESH_SESSION_SUCCESS,
} from './types';
import * as CognitoAuthService from '../services/CognitoAuthService';

export function setSession(session) {
  return {
    type: SET_SESSION,
    payload: session,
  };
}

export function clearSession() {
  return {
    type: CLEAR_SESSION,
    payload: null,
  };
}

// Refresh the access token via the Cognito SDK (transparently uses the
// refresh token under the hood). RTK Query's baseQueryWithReauth calls
// this — and replays the original request itself — so this thunk no
// longer needs to know about the failing action. On refresh failure the
// caller dispatches CLEAR_SESSION.
export function refreshSession() {
  return async (dispatch, getState) => {
    dispatch({ type: REFRESH_SESSION });
    try {
      const cognitoSession = await CognitoAuthService.getCurrentSession();
      if (!cognitoSession) {
        dispatch(onFailedRefresh(new Error('No active Cognito session')));
        return null;
      }
      const accessToken = cognitoSession.getAccessToken().getJwtToken();
      const refreshToken = cognitoSession.getRefreshToken().getToken();
      const current = (getState().session && getState().session.current) || {};
      const newSession = { ...current, token: accessToken, refreshToken };
      dispatch(setSession(newSession));
      dispatch({ type: REFRESH_SESSION_SUCCESS, payload: newSession });
      return newSession;
    } catch (err) {
      dispatch(onFailedRefresh(err));
      return null;
    }
  };
}

function onFailedRefresh(error) {
  return (dispatch) => {
    dispatch(clearSession());
    dispatch({
      type: REFRESH_SESSION_FAILED,
      payload: error,
    });
  };
}
